import {IApplicationData} from "../../application/types/IApplicationData";
import {IRegistrationSentApplicationsSummary} from "../types/IRegistrationSentApplicationsSummary";

export const getRegistrationSentApplicationsSummary = (
    mainApplication: Pick<IApplicationData, "property"> | null,
    multileadPropertyIds: number[]
): IRegistrationSentApplicationsSummary => {
    const mainPropertyIds = mainApplication ? [typeof mainApplication.property === "number" ? mainApplication.property : null] : [];
    const sentPropertyIds = [...mainPropertyIds, ...multileadPropertyIds];
    const uniqueSentPropertyIds = sentPropertyIds.filter((propertyId, index) => propertyId === null || sentPropertyIds.indexOf(propertyId) === index);

    return {
        count: uniqueSentPropertyIds.length,
        propertyIds: uniqueSentPropertyIds.filter((propertyId): propertyId is number => propertyId !== null)
    };
};
import {IApplicationData} from "../../application/types/IApplicationData";
import {IRegistrationSentApplicationsSummary} from "../types/IRegistrationSentApplicationsSummary";

export const getRegistrationSentApplicationsSummary = (
    mainApplication: Pick<IApplicationData, "property"> | null,
    multileadPropertyIds: number[]
): IRegistrationSentApplicationsSummary => {
    const mainPropertyIds = mainApplication ? [typeof mainApplication.property === "number" ? mainApplication.property : null] : [];
    const sentPropertyIds = [...mainPropertyIds, ...multileadPropertyIds];
    const uniqueSentPropertyIds = sentPropertyIds.filter((propertyId, index) => propertyId === null || sentPropertyIds.indexOf(propertyId) === index);

    return {
        count: uniqueSentPropertyIds.length,
        propertyIds: uniqueSentPropertyIds.filter((propertyId): propertyId is number => propertyId !== null)
    };
};
